const FR = {
  selected_file: 'fichier sélectionné',
  selected_files: 'fichiers sélectionnés',
}

export { FR }
